const actions = {};

export default actions;



// WEBPACK FOOTER //
// ./scripts/store/actions.js